import { IDiscordServerState } from 'models'
import { orderRef, order } from 'constant'

/* ------------- Initial State ------------- */

export const DISCORD_SERVER_INITIAL_STATE: IDiscordServerState = {
  collection: [],
  loading: false,
  limit: 10,
  isRequesting: false,
  hasInitialized: false,
  hasDataToLoad: true,
  orderRef: orderRef.CREATED_AT,
  order: order.DESC,
}
